import React from 'react'
import { shallow } from 'enzyme'
import AllTable from '../AllTable'
import LoanRow from '../LoanRow'
import Loader from '../../common/Loader'
import productUsesDefaultModel from '../../common/helpers/productUsesDefaultModel'
import { Draggable } from 'react-beautiful-dnd'

describe('<AllTable />', () => {
  let wrapper, instance, props
  beforeEach(() => {
    props = {
        loans: [
            {
                id: 1,
                app_number: 1,
                notifications: [],
                priority: 1,
                company_name: 'test biz',
                borrower_id: 2,
                borrower_name: 'test borrower',
                enable_advisor: false,
                amount_format: '100,000',
                smart_rate: 4,
                partner_name: 'test partner',
                lender_name: 'test lender',
                state: 'funded',
                audit_handed_off_at: 2393939344,
                days_since_assigned: 10,
                active_items: [],
                showActivity: false,
                activeTab: 'audit'
              }
        ],
        loansData: [
            {
                lastPredictionDataPermutation: "credit",
                needsRedecision: false,
                smartRate: 3,
                rid:1,
                product: {
                    category: 'paycheck_protection',
                    finalDecision: "{\"default_complete_prediction_threshold\":0,\"interim_month_cutoff\":3,\"num_maybe_periods\":0,\"replace_short_interim_with_tax_return\":false,\"business_dscr\":{\"tax_return_0\":{\"required\":false,\"min_dscr\":1.0},\"tax_return_1\":{\"required\":false,\"min_dscr\":1.0},\"interim_year\":{\"required\":false,\"min_dscr\":1.0}},\"global_dscr\":{\"tax_return_0\":{\"required\":false,\"min_dscr\":1.25},\"tax_return_1\":{\"required\":false,\"min_dscr\":1.25},\"interim_year\":{\"required\":false,\"min_dscr\":1.25}}}",
                }
            },
            {
                lastPredictionDataPermutation: "credit",
                needsRedecision: false,
                smartRate: 3,
                rid:1,
                product: {
                    category: 'working_capital',
                    finalDecision: "{\"default_complete_prediction_threshold\":0,\"interim_month_cutoff\":3,\"num_maybe_periods\":0,\"replace_short_interim_with_tax_return\":false,\"business_dscr\":{\"tax_return_0\":{\"required\":false,\"min_dscr\":1.0},\"tax_return_1\":{\"required\":false,\"min_dscr\":1.0},\"interim_year\":{\"required\":false,\"min_dscr\":1.0}},\"global_dscr\":{\"tax_return_0\":{\"required\":false,\"min_dscr\":1.25},\"tax_return_1\":{\"required\":false,\"min_dscr\":1.25},\"interim_year\":{\"required\":false,\"min_dscr\":1.25}}}",
                }
            }
        ],
        latestPredictionsForLoans: [
            {
                id: 1,
                loanId: 1,
                riskRating: 0.111,
                smartRate: null,
            }
        ],
        loading: false,
        activeTab: "all",
        csrfToken:"abcd",
        customerService: true,
        enableEdit: true,
        isDraggable: true,
    }
    wrapper = shallow(<AllTable {...props} />)
    instance = wrapper.instance()
  })
  describe('#isPPPLoan', () => {
    it('should reutrn true when paycheck_protection loan is passed', () => {
        const isPPP = instance.isPPPLoan(props.loansData[0])
        expect(isPPP).toBeTruthy();
    })
    it('should reutrn false when working_captial loan is passed', () => {
        const isPPP = instance.isPPPLoan(props.loansData[1])
        expect(isPPP).toBeFalsy();
    })
  })
  
})